import { Inject, Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { SearchProjectModel } from "src/app/shared/model/SearchProject.model";
import { BaseService } from "../base.service";
import { IAppConfig } from "../Config/app-config.model";
import { PagedProjectList } from "./project-search-list-item";
import { KeyValueItem } from "../KeyValueItem";
import { DocumentTypeModel } from "src/app/shared/model/DocumentType.model";
import { StateAgency } from "src/app/shared/model/StateAgency.model";
import { Regulation } from "src/app/shared/model/regulation.model";
import { ThresholdCategory } from "src/app/shared/model/threshold-category.model";
import { ProjectGeneralInfo } from "src/app/shared/model/project-general-info.model";
import { ProjectType } from "src/app/shared/model/projectType.model";
import { TownModel } from "src/app/shared/model/town.model";
import { AnalystModel } from "src/app/shared/model/Analyst.model";
import { DeterminationModel } from "src/app/shared/model/Determination.model";
import { Watershed } from "src/app/shared/model/watershed.model";
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class ProjectService extends BaseService {
  public datePipe: DatePipe;

  constructor(
    public _injector: Injector,
    @Inject("appconfig") private configParam: IAppConfig
  ) {
    super(_injector);
    this.datePipe = this._injector.get(DatePipe);
  }

  GetProject(projectId: string): Observable<ProjectGeneralInfo> {
    return this.Get<ProjectGeneralInfo>(
      `${this.configParam.ApiConfig.API_ENDPOINT}Project/${projectId}`
    );
  }

  SearchProjects(
    searchModel: SearchProjectModel
  ): Observable<PagedProjectList> {
    let QueryStr = "";

    QueryStr = this.FilterSubmittalType(
      searchModel.submittalType,
      this.FilterProjectName(
        searchModel.projectName,
        this.FilterProjectNumber(
          searchModel.projectNumber,
          this.FilterProjectType(
            searchModel.projectType,
            this.FilterProjectId(
              searchModel.projectId,
              this.FilterStateWide(
                searchModel.statewide,
                this.FilterCity(
                  searchModel.town,
                  this.FilterSubmittalDateFrom(
                    searchModel.submittalDateFrom,
                    this.FilterSubmittalDateTo(
                      searchModel.submittalDateTo,
                      this.FilterProponentName(
                        searchModel.proponentName,
                        this.FilterDetermination(
                          searchModel.determination,
                          this.FilterWatershed(
                            searchModel.watershed,
                            this.FilterAnalyst(
                              searchModel.mepaAnalyst,
                              this.FilterAgency(
                                searchModel.agencies,
                                this.FilterAction(
                                  searchModel.agencyActions,
                                  this.FilterThresholds(
                                    searchModel.thresholds,
                                    this.FilterRegulations(
                                      searchModel.regulations,
                                      QueryStr
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  searchModel.statewide
                )
              )
            )
          )
        )
      )
    );

    let sortFilter = "";

    if (searchModel.sort && searchModel.sort !== null) {
      sortFilter = searchModel.sort.getSortQueryString(
        this.GetSortColumnMapping().find(
          (k) => k.Key === searchModel.sort.sortColumn
        ).Value
      );
    }

    return this.Get<PagedProjectList>(
      `${this.configParam.ApiConfig.API_ENDPOINT}Project/search?${QueryStr}isExactAgency=${searchModel.isExactAgency}&isExactAction=${searchModel.isExactAction}&isExactThresholdCat=${searchModel.isExactThresholdCat}&isExactThreshold=${searchModel.isExactThreshold}&PageSize=${searchModel.pageSize}&Page=${searchModel.page}${sortFilter}`
    );
  }

  FilterStateWide(statewide: boolean, queryStr: string): string {
    queryStr += "Statewide=" + statewide + "&";
    return queryStr;
  }

  FilterRegulations(regulations: Regulation[], QueryStr: string): any {
    regulations.forEach((regulation) => {
      QueryStr =
        QueryStr == ""
          ? "regulations=" + regulation.regulationId + "&"
          : QueryStr + "&regulations=" + regulation.regulationId + "&";
    });
    return QueryStr;
  }
  FilterThresholds(thresholds: ThresholdCategory[], QueryStr: any): string {
    thresholds.forEach((threshold) => {
      QueryStr =
        QueryStr == ""
          ? "thresholds=" + threshold.thresholdId + "&"
          : QueryStr + "&thresholds=" + threshold.thresholdId + "&";
    });
    return QueryStr;
  }
  FilterAction(agencyActions: any, QueryStr: string): string {
    agencyActions.forEach((stateAgency) => {
      QueryStr =
        QueryStr == ""
          ? "actionsId=" + stateAgency.actionId + "&"
          : QueryStr + "&actionsId=" + stateAgency.actionId + "&";
    });
    return QueryStr;
  }

  FilterAgency(agencies: StateAgency[], QueryStr: string): string {
    agencies.forEach((stateAgency) => {
      QueryStr =
        QueryStr == ""
          ? "agenciesId=" + stateAgency.agencyId + "&"
          : QueryStr + "&agenciesId=" + stateAgency.agencyId + "&";
    });
    return QueryStr;
  }

  private FilterWatershed(watershed: Watershed, QueryStr: string): string {
    if (watershed && watershed.watershedId != null) {
      QueryStr += "Watershed=" + watershed.watershedId + "&";
    }
    return QueryStr;
  }

  private FilterDetermination(
    determination: DeterminationModel,
    QueryStr: string
  ): string {
    if (
      determination &&
      determination != null &&
      determination.determinationId !== null
    ) {
      QueryStr += "Determination=" + determination.determinationId + "&";
    }
    return QueryStr;
  }

  private FilterProponentName(proponentName: string, QueryStr: string): string {
    if (proponentName && proponentName.length > 0) {
      QueryStr += "ProponentName=" + proponentName + "&";
    }
    return QueryStr;
  }

  private FilterProjectType(
    projectType: ProjectType,
    QueryStr: string
  ): string {
    if (projectType && projectType != null && projectType.projectTypeId != "") {
      QueryStr += "ProjectType=" + projectType.projectTypeId + "&";
    }
    return QueryStr;
  }

  private FilterSubmittalType(type: DocumentTypeModel, QueryStr: string) {
    if (type && type.documentTypeName !== "Select One") {
      QueryStr += "SubmittalType=" + type.documentTypeId + "&";
    }
    return QueryStr;
  }

  private FilterProjectName(name: string, QueryStr: string) {
    if (name && name.length > 0) {
      QueryStr += "ProjectName=" + name + "&";
    }
    return QueryStr;
  }

  private FilterProjectNumber(projectNumber: string, QueryStr: string) {
    if (projectNumber && projectNumber.length > 0) {
      QueryStr += "ProjectNumber=" + projectNumber + "&";
    }
    return QueryStr;
  }

  private FilterProjectId(projectId: string, QueryStr: string) {
    if (projectId && projectId.length > 0) {
      QueryStr += "ProjectId=" + projectId + "&";
    }
    return QueryStr;
  }

  FilterCity(townId: TownModel, queryStr: string, statewide: boolean = false) {
    if (
      townId !== undefined &&
      townId !== null &&
      townId.TownId != -1 &&
      statewide == false
    ) {
      queryStr += "City=" + townId.TownId + "&";
    }
    return queryStr;
  }

  private FilterSubmittalDateFrom(
    submittalDateFrom: Date,
    QueryStr: string
  ): string {
    if (submittalDateFrom && submittalDateFrom) {
      QueryStr +=
        "SubmittalDateFrom=" +
        this.datePipe.transform(submittalDateFrom, "M/d/yyyy") +
        "&";
    }
    return QueryStr;
  }

  private FilterSubmittalDateTo(
    submittalDateTo: Date,
    QueryStr: string
  ): string {
    if (submittalDateTo && submittalDateTo) {
      QueryStr +=
        "SubmittalDateTo=" +
        this.datePipe.transform(submittalDateTo, "M/d/yyyy") +
        "&";
    }
    return QueryStr;
  }

  private FilterAnalyst(mepaAnalyst: AnalystModel, QueryStr: string): string {
    if (mepaAnalyst && mepaAnalyst != null && mepaAnalyst.analystId != "") {
      QueryStr += "MEPAAnalyst=" + mepaAnalyst.analystId + "&";
    }
    return QueryStr;
  }

  GetSortColumnMapping(): KeyValueItem[] {
    return [
      new KeyValueItem("EEANo", "0"),
      new KeyValueItem("Project Name", "1"),
      new KeyValueItem("Location", "2"),
      new KeyValueItem("Submittal Type", "3"),
      new KeyValueItem("Publish Date", "4"),
      new KeyValueItem("Review Due Date", "5"),
      new KeyValueItem("Analyst", "6"),
      new KeyValueItem("Status", "7"),
    ];
  }
}
